import { TFunction } from 'i18next';
import {
  Condition,
  ConditionOperator,
} from '@aphp-ema/common/conditions/condition.schemas';
import { operatorTranslationKeys } from '@/features/questionnaires/constants/conditionOperators';
import type { Question } from '@aphp-ema/common/questionnaire';
import { translatePatientDataValue } from '@/features/questionnaires/utils/translationHelpers';

export function getPreviewText(
  condition: Condition,
  previousQuestions: Question[],
  initialQuestions: Question[],
  t: TFunction,
): string {
  if (!condition.target || !condition.operator) {
    return '';
  }

  let targetLabel = '';

  if (condition.target.source === 'question') {
    const questionTarget = condition.target;
    const targetQuestion = previousQuestions.find(
      (q) => q.id === questionTarget.questionId,
    );

    if (!targetQuestion) {
      return '';
    }

    targetLabel =
      targetQuestion.label ||
      `Question ${previousQuestions.indexOf(targetQuestion) + 1} - ${t('pages.studies.questions.conditions.noLabelYet')}`;
  } else if (condition.target.source === 'initial-question') {
    const questionTarget = condition.target;
    const targetQuestion = initialQuestions.find(
      (q) => q.id === questionTarget.questionId,
    );

    if (!targetQuestion) {
      return '';
    }

    targetLabel =
      targetQuestion.label ||
      `Initial Question ${initialQuestions.indexOf(targetQuestion) + 1} - ${t('pages.studies.questions.conditions.noLabelYet')}`;
  } else if (condition.target.source === 'patientData') {
    targetLabel = t(
      `pages.studies.questions.conditions.${condition.target.field}`,
    );
  }

  const operatorText = t(
    operatorTranslationKeys[condition.operator as ConditionOperator],
  );

  let valueText = '';
  if (
    condition.operator !== 'is_empty' &&
    condition.operator !== 'is_not_empty'
  ) {
    if (
      condition.operator === 'between' &&
      'minValue' in condition &&
      'maxValue' in condition
    ) {
      valueText = ` ${condition.minValue} ${t('pages.studies.questions.conditions.and')} ${condition.maxValue}`;
    } else if ('value' in condition && condition.value !== undefined) {
      if (condition.target.source === 'patientData') {
        if (
          (condition.target.field === 'gender' ||
            condition.target.field === 'chronicIllnesses') &&
          condition.value
        ) {
          valueText = ` ${translatePatientDataValue(t, condition.target.field, condition.value)}`;
        } else {
          valueText = ` ${condition.value}`;
        }
      } else {
        valueText = ` ${condition.value}`;
      }
    }
  }

  return `${targetLabel} ${operatorText}${valueText}`;
}
